import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addWithdrawRequet, getWalletStats } from "../../store/wallet/walletActions";
import { TextInput } from "../../components/inputs";
import { errorToast } from "../../utils";
import { Toaster } from "react-hot-toast";

const WithdrawRequest = ({setIsRequest, initView}) => {
    const [isDisabled, setIsDisabled] = useState(false)
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const { balance } = useSelector((state) => state.wallet);
    const { handleSubmit, 
        reset, 
        formState: { errors }, 
        register, 
        control, 
    } = useForm()

    const onAddRequest = (data) => {
        setIsDisabled(true);
        dispatch(addWithdrawRequet(data))
            .unwrap()
            .then(() => {
                dispatch(getWalletStats())
                initView()
                setIsDisabled(false)
                setIsRequest(false)
                reset()
            })
            .catch((e) => {
                errorToast(e.error)
            })
    }

    return <div className="bg-white rounded-2xl p-5 sm:p-6 mx-auto 2xl:w-1/2 sm:w-3/4 border border-nt-blue/10 shadow-sm">
        <Toaster />
        <h2 className="text-nt-blue text-xl font-semibold mb-1">New Withdrawal Request</h2>
        <p className="text-sm text-gray-500 mb-5">Fill in your payout details to submit a request.</p>
        <form onSubmit={handleSubmit(onAddRequest)}>
            <TextInput
                name="email"
                label="PayPal Email"
                type="email"
                errors={errors}
                defaultValue={user.email}
                register={register}
                control={control}
                validationSchema={{
                    required: "This field is required"
                }}
            />
            <div className="flex flex-col sm:flex-row items-center sm:gap-5 mb-5">
                <TextInput
                    name={`amount`}
                    label={"Withdrawal Amount"}
                    errors={errors}
                    inputClassname="w-full"
                    placeholder="10"
                    type="number"
                    register={register}
                    minHtml={10}
                    maxHtml={balance}
                    control={control}
                    validationSchema={{
                        required: "This field is required",
                        validate: (value) => {
                            return value < 10 ? "Minimum value is 10" : value > balance ? "Maximum value is " + balance : true;
                        }
                    }}
                />
                <span className="p-2 px-3 rounded-md text-center block bg-nt-blue/10 text-nt-blue text-sm font-medium border border-nt-blue/20">Available balance: {balance}€</span>
            </div>
            <p className="text-sm text-nt-blue mb-5"><b>Note:</b> PayPal transaction fees are deducted from your side.</p>
            <div className="w-full flex gap-3 justify-center align-center sm:justify-end">
                <button disabled={isDisabled} className="bg-nt-blue hover:opacity-90 disabled:opacity-70 disabled:cursor-not-allowed w-44 text-white p-2.5 rounded-lg transition-opacity">Submit Withdrawal</button>
                <button type="button" onClick={() => setIsRequest(false)} className="w-36 bg-nt-red hover:opacity-90 text-white p-2.5 rounded-lg transition-opacity">Back to History</button>
            </div>
        </form>
    </div>
}

export { WithdrawRequest }